module.exports = __webpack_public_path__ + "static/media/ny-times.d7bd5d7b.png";